import { render, staticRenderFns } from "./SearchScreen.vue?vue&type=template&id=71c2004a&scoped=true&"
import script from "./SearchScreen.vue?vue&type=script&lang=js&"
export * from "./SearchScreen.vue?vue&type=script&lang=js&"
import style0 from "./SearchScreen.vue?vue&type=style&index=0&id=71c2004a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2004a",
  null
  
)

export default component.exports